// Ask-and-show without each page owning dialog state. <DialogHost /> (mounted once in App) renders what these request.
// Without a host (a unit test, a script) confirmAction falls back to the browser's confirm so nothing is silently approved.
let host = null;
export const registerDialogHost = (h) => { host = h; return () => { if (host === h) host = null; }; };

const DANGER = /\b(delete|remove|cannot be undone|can't be undone|permanently|reverse[sd]?)\b/i;
const VERBS = ["Delete", "Remove", "Cancel", "Withdraw", "Post", "Pay", "Create", "Generate", "Send", "Set", "Add", "Approve", "Reject", "Close"];

/** Picks a button label from the sentence ("Delete PO 12?" -> "Delete") so the button says what it does, not "OK". */
export function labelFor(message) {
  const first = String(message || "").trim().split(/\s+/)[0]?.replace(/[^A-Za-z]/g, "");
  const verb = VERBS.find((v) => v.toLowerCase() === (first || "").toLowerCase());
  return verb || "Confirm";
}

/**
 * confirmAction("Delete PO 12? This can't be undone.")  or  confirmAction({ title, description, kind, confirmLabel, cancelLabel })
 * Resolves true only if the person confirms; Escape, Cancel or clicking outside resolve false.
 */
export function confirmAction(input) {
  const opts = typeof input === "string" ? { message: input } : { ...input };
  const message = opts.message ?? opts.description ?? "";
  const kind = opts.kind || (DANGER.test(`${opts.title || ""} ${message}`) ? "danger" : "warning");
  if (!host) return Promise.resolve(typeof window !== "undefined" && window.confirm ? window.confirm(opts.title ? `${opts.title}\n${message}` : message) : false);
  const label = opts.confirmLabel || labelFor(opts.title || message);
  const title = opts.title || String(message).split(/(?<=[?.!])\s/)[0] || "Are you sure?";
  const description = opts.title ? message : String(message).slice(title.length).trim();
  return new Promise((resolve) => host.confirm({
    kind, title, description, confirmLabel: label,
    cancelLabel: opts.cancelLabel || (label === "Cancel" ? "Keep it" : "Cancel"), resolve,
  }));
}

/** showNotice({ kind: "error"|"warning"|"info", title, description, items, itemsHeading, footnote }) */
export function showNotice(opts) { if (host) host.notice(opts); }
